import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";
import { AddressMinData, DefaultUSCountry, AddressMinSchema, ReactSelectOptionSchema } from "../generic";
import { ReactSelectOption } from "../../models/generic";
import { BasicOrganizationProfile } from "../../models/organization";
import { BasicProfile as BasicMemberProfile } from "../../models/member";

export interface PostJobData {
    categoryId: number;
    description: string;
    howToApply: string;
    location: AddressMinData;
    organization: ReactSelectOption | BasicOrganizationProfile | null;
    organizationId: number;
    refMemberId?: number;
    refMemberName?: ReactSelectOption | BasicMemberProfile | null;
    subscribe: boolean;
    title: string;
    userIsMember: boolean;
}

export class PostJob implements FormValidationModel<PostJobData> {
    public data: PostJobData;
    public rules: yup.Schema<PostJobData>;

    public constructor() {
        this.data = {
            categoryId: 1,
            description: "",
            howToApply: "",
            location: {
                countryCode: DefaultUSCountry,
            },
            organization: null,
            organizationId: 0,
            subscribe: true,
            title: "",
            userIsMember: false,
        };
        this.rules = yup.object<PostJobData>().shape({
            categoryId: yup.number().required().label("Job category"),
            description: yup.string().required().label("Description"),
            howToApply: yup.string().required().label("How to apply").max(4000),
            location: AddressMinSchema.required().label("Location"),
            organization: ReactSelectOptionSchema.label("Company/Organization"),
            organizationId: yup.number().min(0).label("Company/Organization"),
            refMemberId: yup.number().when(["userIsMember"], (userIsMember: boolean) => {
                if (!userIsMember)
                    return yup.number().required("Reference member must be a valid record").min(1, "Reference member must be a valid record");
                return yup.number();
            }),
            refMemberName: ReactSelectOptionSchema.when(["userIsMember"], (userIsMember: boolean) => {
                if (!userIsMember)
                    return ReactSelectOptionSchema.required().notOneOf([null, undefined]).label("Reference member");
                return ReactSelectOptionSchema;
            }),
            subscribe: yup.bool().label("Subscribe to candidate alerts"),
            title: yup.string().required().label("Position title").max(255),
            userIsMember: yup.bool(),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/careerCenter/PostJob.ts